// O texto puro com os links no lugar (comentário do feed, atendimento da equipe e do portal, legenda de anexo) —
// desenho da tela de 27/10/2026, §1.2. Devolve um fragmento: texto e `LinkNoTexto` alternados, com a pontuação do
// fim da frase fora do link. Sem link devolve a própria string (nenhum `<a>`, e o texto é o mesmo de antes).
//
// O chat não usa este: a bolha tem `renderTextWithTokens`, onde o link é a primeira alternativa da regex, para
// ganhar de `@`, `#` e `:x:` dentro dele.
import { Fragment, createElement, type ReactElement } from "react";

import { acharLinks } from "@/lib/links/links";
import type { TomDoLink } from "@/lib/links/previaDoCartao";

import { LinkNoTexto } from "./LinkNoTexto";

interface Props {
  texto: string;
  tom: TomDoLink;
}

export function TextoComLinks({ texto, tom }: Props): ReactElement | string {
  const links = acharLinks(texto);
  if (links.length === 0) return texto;

  // `createElement`, não `<Fragment key>`: o tagger de dev da Vite injeta `data-dyad-id` em todo elemento JSX, e o
  // React acusaria "Invalid prop supplied to React.Fragment" a cada trecho de texto (ver `limite-dos-avisos.tsx`).
  const partes: ReactElement[] = [];
  let cursor = 0;
  for (const link of links) {
    if (link.inicio > cursor)
      partes.push(createElement(Fragment, { key: `t${cursor}` }, texto.slice(cursor, link.inicio)));
    partes.push(<LinkNoTexto key={`l${link.inicio}`} link={link} tom={tom} />);
    cursor = link.fim;
  }
  if (cursor < texto.length)
    partes.push(createElement(Fragment, { key: `t${cursor}` }, texto.slice(cursor)));
  return <>{partes}</>;
}
